module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/a5e723dbc13c93c497d471903f0c978a.png";